"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DesktopContainer = void 0;
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
var Dashboard_1 = require("Dashboard/Dashboard");
function DesktopContainer(_a) {
    var _b;
    var children = _a.children;
    var _c = __read((0, react_1.useState)(false), 2), isSidebarScrolled = _c[0], setIsSidebarScrolled = _c[1];
    var handleSidebarScroll = function (event) {
        setIsSidebarScrolled(event.currentTarget.scrollTop > 10);
    };
    return (react_1.default.createElement("div", { className: "".concat(Dashboard_1.BASE_CLASS_NAME, "__sidebar") },
        react_1.default.createElement("div", { className: (0, classnames_1.default)((_b = {},
                _b["".concat(Dashboard_1.BASE_CLASS_NAME, "__sidebar-container")] = true,
                _b["".concat(Dashboard_1.BASE_CLASS_NAME, "__sidebar-container--scrolled")] = isSidebarScrolled,
                _b)), onScroll: handleSidebarScroll }, children)));
}
exports.DesktopContainer = DesktopContainer;
